import React from 'react';
import { ISvgProps } from '../svg.types';

export const PersonalityReportTraditionnel = (props: ISvgProps) => (
  <svg
    id="Calque_2"
    x={0}
    y={0}
    viewBox="0 0 138 122"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {`.st1{fill:#5230a8}.st3{fill:#001336}.st4{fill:#f09473}.st8{fill:#ff9e7b}.st9{fill:#472906}.st10{fill:#0f2347}.st17{fill:#3a242f}.st24{fill:#ffa881}.st25{fill:#000e2c}.st27{fill:#ffb896}.st29{fill:#fff0f8}`}
    </style>
    <linearGradient
      id="SVGID_1_"
      gradientUnits="userSpaceOnUse"
      x1={-326.51}
      y1={359.01}
      x2={-325.51}
      y2={359.01}
      gradientTransform="matrix(100 0 0 -100 32670 35962)"
    >
      <stop offset={0.26} stopColor="#ffcdba" />
      <stop offset={1} stopColor="#ff9ba1" />
    </linearGradient>
    <circle cx={69} cy={61} r={50} fill="url(#SVGID_1_)" />
    <g transform="translate(4 19)">
      <path
        className="st1"
        d="M117 36.9h3.4v49.6H117V36.9zm-75.4 0H45v49.6h-3.4V36.9z"
      />
      <path
        d="M33.2 63.5H128V67H33.2v-3.5zm91.9-2.7H36c-1.5 0-2.8-1.2-2.9-2.8v-.6c.1-1.6 1.3-2.9 2.9-2.8h89.1c1.5 0 2.8 1.2 2.9 2.8v.6c-.1 1.6-1.3 2.8-2.9 2.8zm0-8H36c-1.5 0-2.8-1.2-2.9-2.8v-.6c.1-1.6 1.3-2.9 2.9-2.8h89.1c1.5 0 2.8 1.2 2.9 2.8v.6c-.1 1.6-1.3 2.9-2.9 2.8zm0-8H36c-1.5 0-2.8-1.2-2.9-2.8v-.6c.1-1.6 1.3-2.9 2.9-2.8h89.1c1.5 0 2.8 1.2 2.9 2.8v.6c0 1.6-1.3 2.9-2.9 2.8z"
        fill="#633dee"
      />
      <path
        className="st1"
        d="M38 41.7c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .5 1 1zm87 0c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .5 1 1zm-87 8c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zm87 0c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zm-87 8c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zm87 0c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1z"
      />
      <path
        className="st3"
        d="M53.8 33.8c.5.8 3.8 6.4 1.5 10.5s-14 5.8-14.8 1.2c-.4-3.2-.1-6.4 1-9.4.5-1.3 1.1-2.6 1.8-3.7.7-.9 3.5-1.9 3.5-1.9s3.4.7 3.7 1.1c1 .7 2.1 1.5 3.3 2.2z"
        transform="translate(34 5)"
      />
      <path
        className="st4"
        d="M27.3 42.8c0-1.2.9-2.2 2.1-2.3 1 0 4.1-1.2 9.8-11.6.2-.6.6-1.1 1-1.5.9-.8 2.3-.6 3.1.3.6.8.7 1.9.1 2.7l-.3.6c-6.8 12.3-11 13.8-13.5 13.9h-.1c-1.2 0-2.1-.9-2.2-2.1z"
        transform="translate(34 5)"
      />
      <path
        d="M39.3 28.9c.2-.6.6-1.1 1-1.5.9-.8 2.3-.6 3.1.3.6.8.7 1.9.1 2.7l-.4.6c-1.4 2.6-3 5.1-4.7 7.4l-.1-.2-2.3-4c1-1.3 2.1-3.1 3.3-5.3z"
        fill="#ff3e14"
        transform="translate(34 5)"
      />
      <path
        d="M39.6 28.3c.4-.7 1.2-1.1 2-1.1h2.9l1.4.1 1.8.7c2 .9 3 3.1 2.2 5.2-1.1 2.6-2.3 5.1-3.7 7.6 0 0-1 8.3-1.1 8.5-3.1.2-6.6-1.1-9.9-1-.2-.6 3.8-19.1 4.4-20z"
        fill="#ff582b"
        transform="translate(34 5)"
      />
      <path
        d="M46.8 36.1c0-.1-1-4.9-1-4.9l-1 5.1 2.1.9-.1-1.1z"
        opacity={0.44}
        transform="translate(34 5)"
      />
      <path
        className="st8"
        d="M46.9 36.7c.2 0 3.2 1.9 3.2 1.9l-3.4-2.9.2 1zM46.2 22.8l-.2 4.4s-3.2 2.8-3.5 2.9c-.3.1-1.1-2.2-.9-2.9.2-.6.4-2.5.5-2.7.1-.2-.1-2.6-.1-3.2 0-.4 0-.8.1-1.2l4.1 2.7z"
        transform="translate(34 5)"
      />
      <path
        className="st8"
        d="M37.8 18.9c0 4 2.5 7.9 4.6 6.6 2.8-1.7 5.6-2.7 5.6-6.8s-3.2-7.2-5.7-7.2-4.5 3.4-4.5 7.4z"
        transform="translate(34 5)"
      />
      <path
        className="st9"
        d="M37.7 49.9h-2.5c-.2 0-.4-.1-.6-.2-.2-.2-.2-.4-.2-.6v-.7c0-.4.3-.6.6-.6h2.7c.2 0 .4.1.6.2.2.2.2.4.2.6v.4c0 .5-.4.9-.8.9zm-2.7-2c-.2 0-.4.2-.4.4v.7c0 .3.2.5.5.5h2.5c.3 0 .6-.2.6-.5v-.5c0-.1-.1-.3-.2-.4-.1-.1-.2-.2-.4-.2H35z"
        transform="translate(34 5)"
      />
      <path
        className="st9"
        d="M38.4 48.9h-2.1c-.1 0-.1-.1-.1-.2s.1-.1.1-.1h2.1c.1 0 .1.1.1.1 0 .1-.1.2-.1.2z"
        transform="translate(34 5)"
      />
      <path
        className="st10"
        d="M27.2 49.7h-.5c-2.2 0-3.9 1.5-3.9 3.3v1.8c1.7.3 3.4.9 5 1.6.2.1.3.1.4.2l-.1.5c1 .2 4.8.2 8.5.3 4.6.2 8.5-2.8 8.5-6.7v-1.5l-17.9.5z"
        transform="translate(34 5)"
      />
      <path
        className="st10"
        d="M34.8 57.3c0-1.2.3-2.4.9-3.4.3-.8.7-1.6 1.2-2.3l-.5-.4-13.2.4S18 61.2 31 77.1c.5-.3 1.1-.6 1.7-.9 0 0-2.7-5.8-4.3-19.3 2.1 0 4.3.1 6.4.4z"
        transform="translate(34 5)"
      />
      <path
        d="M23.7 42.9c.1-.1.2-.2.4-.3 1.2-.8 2.7-.9 4-.3l.5.2 16.6 6.8v2.3c0 3.2-2.5 5.9-5.7 6.1-1.7.1-3.3-.2-4.8-1-3.1-1.5-6.8-5.9-8-6.9C22.9 62.7 23 69 23 69c-.6 0-1.3.1-1.9.2-5-17.4 1-24.7 2.6-26.3z"
        fill="#153463"
        transform="translate(34 5)"
      />
      <path
        className="st4"
        d="M29.4 47.5c1.6-.4 3-3.3 2.6-4.9-.4-1.6-2.1-2.3-3.8-1.9-1.7.4-1.7 2.3-1.3 4s.9 3.2 2.5 2.8z"
        transform="translate(34 5)"
      />
      <path
        d="M32.3 74.7c-.9.7-1.7 1.6-2.2 2.7-.9 1.8-2.1 4.1-2 4.4.1.3.2.5.4.7 0 0 4.6-6.3 4.7-6.7.2-.4-.9-1.1-.9-1.1zm-11.2-5.6l1.9-.2c-.1 1-1.8 7.9-1.8 7.9-.3-.1-.5-.2-.7-.4-.2-.3 0-2.9.2-4.9-.1-.8.1-1.7.4-2.4z"
        fill="#232323"
        transform="translate(34 5)"
      />
      <path
        className="st3"
        d="M51.1 35.3l.1.4c-1.5.3-3.1.6-4.6.8 0-.2-.1-.4-.1-.5 0-.1 4.6-.7 4.6-.7z"
        transform="translate(34 5)"
      />
      <path
        d="M85.4 20.8c.2-.2.3-.5.4-.8l.3-.9c.2-.6.1-1.2-.3-1.7-.3-.3-.8-.5-1.3-.6-.3 0-.6 0-.9.1-.3.1-.5.3-.8.4 0-.6-.1-1.3-.4-1.8-.3-.5-.8-.8-1.4-.9-.6-.1-1.1 0-1.6.3-.1.1-.3.1-.4.2-.1.1-.2.1-.3.2-.1 0-.2 0-.3-.1-.1-.1-.2-.2-.4-.3-.5-.4-1.2-.5-1.9-.3-.3.1-.6.3-.8.6-.2.2-.3.6-.5.7-.2.2-.2 0-.3-.1-.1-.1-.3-.2-.4-.3l-.6-.3c-.3-.1-.8-.1-.9.4v1.2c0 .2 0 .3.1.5v.3c0 .1-.3 0-.4.1-.2 0-.4 0-.6.1-.1.1-.3.2-.3.3v.6c-.2-.1-1.1-.4-1.2 0 0 .2 0 .3.1.4.1.2.3.4.4.6.3.4.7.8 1.2 1.1-.4.2-.5.6-.4.9 0 .1.1.2.2.3.2.1.4.2.6.2h.4c.3 0 .7 0 1-.1.6-.1 1.1-.4 1.5-.8.1-.1.2-.2.3-.2h.4c.3 0 .7-.1 1-.3 0 .4.1.9.3 1.3.1.3.4.4.7.4 1 .1 1.9 0 2.8 0-.9.2-1.9.3-2.8.5-.4.1-.1.4.1.6.3.3.5.7.6 1.2.4-.6 1.1-.9 1.8-.8.8.2 1.3.8.8 1.5-.3.4-.8.7-1.2.8.3.4.2.9.4 1.3s.5.7.9 1c.1 0 .2 0 .2.1s.1.2.2.2c.4.3 1 .2 1.4-.1.3-.4.3-.9 0-1.2.4-.2 1.2-.4 1.1-1.1 1-.1 3.3-1.6 2-2.8.8-.4 1.2-1.4.9-2.2-.3-.3-1-.7-1.7-.7"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3a242f"
      />
      <g transform="translate(59)">
        <path
          d="M38.4 32.6l-3.8-1.3h-6.2l-3.8 1.3c-2.7.9-4.5 3.4-4.7 6.2L19.2 58l11.9.3 12.5.1-.5-19.6c-.1-2.8-2-5.3-4.7-6.2z"
          fill="#862784"
        />
        <linearGradient
          id="SVGID_2_"
          gradientUnits="userSpaceOnUse"
          x1={-336.409}
          y1={312.402}
          x2={-336.412}
          y2={311.952}
          gradientTransform="matrix(6.22 0 0 -8.21 2124.06 2592.34)"
        >
          <stop offset={0} stopColor="#ff8454" />
          <stop offset={1} stopColor="#ffa881" />
        </linearGradient>
        <path
          d="M28.5 25.3h6.2V32c0 .8-.7 1.5-1.5 1.5H30c-.8 0-1.5-.7-1.5-1.5v-6.7z"
          fill="url(#SVGID_2_)"
        />
        <linearGradient
          id="SVGID_3_"
          gradientUnits="userSpaceOnUse"
          x1={-353.739}
          y1={324.546}
          x2={-353.736}
          y2={324.25}
          gradientTransform="matrix(9 0 0 -13.6401 3215 4444.914)"
        >
          <stop offset={0} stopColor="#ff8454" />
          <stop offset={1} stopColor="#ffa881" />
        </linearGradient>
        <path
          d="M31.4 29c-2.5 0-4.5-2-4.5-4.5v-4.7c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5v4.7c0 2.5-2 4.5-4.5 4.5z"
          fill="url(#SVGID_3_)"
        />
        <path
          className="st17"
          d="M27.5 24s1-5.8.5-7.1c-.4-1.3-2-.1-2.3.2s.3 6.8.3 6.8l1.5.1z"
        />
        <path
          className="st17"
          d="M35.2 23.1c-.2 1.2-1.3 2.1-2.6 2.1h-2.5c-1.3 0-2.3-.9-2.6-2.1H27V27c0 1.7 1.3 3 3 3h2.8c1.7 0 3-1.3 3-3v-3.9h-.6z"
        />
        <path
          className="st17"
          d="M35.2 24s-1-5.8-.5-7.1c.3-.9 1.3-1.4 2.2-1.1.3.2-.3 8.1-.3 8.1l-1.4.1z"
        />
        <linearGradient
          id="SVGID_4_"
          gradientUnits="userSpaceOnUse"
          x1={-190.86}
          y1={263.55}
          x2={-190.847}
          y2={262.243}
          gradientTransform="matrix(1.73 0 0 -3.0827 366.76 830.443)"
        >
          <stop offset={0} stopColor="#ff8454" />
          <stop offset={1} stopColor="#ffa881" />
        </linearGradient>
        <path
          d="M35.8 22.8c0-.4.3-.7.7-.7.2 0 .4.1.5.2.3.3.5.7.5 1.2 0 .9-.8 1.7-1.7 1.7-.1 0 0-2.4 0-2.4z"
          fill="url(#SVGID_4_)"
        />
        <linearGradient
          id="SVGID_5_"
          gradientUnits="userSpaceOnUse"
          x1={-190.85}
          y1={263.492}
          x2={-190.837}
          y2={262.184}
          gradientTransform="matrix(1.73 0 0 -3.0827 356.25 830.443)"
        >
          <stop offset={0} stopColor="#ff8454" />
          <stop offset={1} stopColor="#ffa881" />
        </linearGradient>
        <path
          d="M27 22.8c0-.4-.3-.7-.7-.7-.2 0-.4.1-.5.2-.3.3-.5.7-.5 1.2 0 .9.8 1.7 1.7 1.7v-2.4z"
          fill="url(#SVGID_5_)"
        />
        <path
          className="st17"
          d="M37.5 12.9c.8 1.7-1.1 4.4-4.3 5.9s-6.5 1.4-7.3-.3c-.8-1.7 1.1-4.4 4.3-5.9s6.4-1.4 7.3.3z"
        />
      </g>
      <linearGradient
        id="SVGID_6_"
        gradientUnits="userSpaceOnUse"
        x1={-304.909}
        y1={311.63}
        x2={-304.909}
        y2={308.209}
        gradientTransform="matrix(12.2029 0 0 -7.94 3805.553 2529.59)"
      >
        <stop offset={0} stopColor="#003e96" />
        <stop offset={1} stopColor="#000e2c" />
      </linearGradient>
      <path
        d="M87.4 63.1h-5.2c-2.2-.3-3.7-2.3-3.5-4.5.2-1.8 1.7-3.3 3.5-3.5h5.2c2.2.3 3.7 2.3 3.5 4.5-.3 1.9-1.7 3.3-3.5 3.5z"
        fill="url(#SVGID_6_)"
      />
      <linearGradient
        id="SVGID_7_"
        gradientUnits="userSpaceOnUse"
        x1={-310.962}
        y1={281.26}
        x2={-310.962}
        y2={274.418}
        gradientTransform="matrix(15.48 0 0 -3.97 4903.741 1171.85)"
      >
        <stop offset={0} stopColor="#003e96" />
        <stop offset={1} stopColor="#000e2c" />
      </linearGradient>
      <path d="M82.3 59.1h15.5v4H82.3v-4z" fill="url(#SVGID_7_)" />
      <linearGradient
        id="SVGID_8_"
        gradientUnits="userSpaceOnUse"
        x1={-304.911}
        y1={311.63}
        x2={-304.911}
        y2={308.209}
        gradientTransform="matrix(12.2029 0 0 -7.94 3816.826 2529.59)"
      >
        <stop offset={0} stopColor="#003e96" />
        <stop offset={1} stopColor="#000e2c" />
      </linearGradient>
      <path
        d="M98.6 63.1h-5.2c-2.2-.3-3.7-2.3-3.5-4.5.2-1.8 1.7-3.3 3.5-3.5h5.2c2.2.3 3.7 2.3 3.5 4.5-.2 1.9-1.7 3.3-3.5 3.5z"
        fill="url(#SVGID_8_)"
      />
      <linearGradient
        id="SVGID_9_"
        gradientUnits="userSpaceOnUse"
        x1={-290.093}
        y1={333.11}
        x2={-290.093}
        y2={332.024}
        gradientTransform="matrix(8.0376 0 0 -25 2416.526 8383)"
      >
        <stop offset={0} stopColor="#003e96" />
        <stop offset={1} stopColor="#000e2c" />
      </linearGradient>
      <path
        d="M86.9 82h-4.2C80.2 64.4 81 57 81 57h7.6s1.4 2.8-1.7 25z"
        fill="url(#SVGID_9_)"
      />
      <path className="st24" d="M82.7 82h4.2v2.6h-4.2V82z" />
      <path
        className="st25"
        d="M86.3 84.6h-3.2c-1 0-1.8.8-1.8 1.8h6.9c0-1-.9-1.8-1.9-1.8z"
      />
      <linearGradient
        id="SVGID_10_"
        gradientUnits="userSpaceOnUse"
        x1={-290.053}
        y1={333.11}
        x2={-290.053}
        y2={332.024}
        gradientTransform="matrix(8.0298 0 0 -25 2425.037 8383)"
      >
        <stop offset={0} stopColor="#003e96" />
        <stop offset={1} stopColor="#000e2c" />
      </linearGradient>
      <path
        d="M98 82h-4.2c-2.4-17.6-1.7-25-1.7-25h7.6s1.4 2.8-1.7 25z"
        fill="url(#SVGID_10_)"
      />
      <path className="st24" d="M93.8 82H98v2.6h-4.2V82z" />
      <path
        className="st25"
        d="M97.4 84.6h-3.2c-1 0-1.8.8-1.8 1.8h6.9c0-1-.8-1.8-1.9-1.8z"
      />
      <path
        className="st27"
        d="M96 32.2s7.4 2 6 10.8c-1.4 8.8-1.7 11.2-4.5 12.5-2.8 1.2-10.5 1.3-10.5 1.3l-.8-3.8s6.5-.2 8.1-2.7S96 32.2 96 32.2z"
      />
      <path
        className="st27"
        d="M87.8 55c-.1 1.5-1.3 2.6-2.8 2.5h-.2c-1.6-.1-3.8-.5-3.7-2.1 0-.8 1.8-1.2 2.3-1.8s.8-1.2 1.7-1.1c1.5.1 2.7.9 2.7 2.5z"
      />
      <path
        d="M95.9 32.1s.1 8.8-.6 14.3c0 0 2.9 3.1 6 1 .2-1.3.4-2.7.7-4.4 1.7-10.1-6.1-10.9-6.1-10.9z"
        fill="#b13cb5"
      />
      <path
        className="st1"
        d="M45.9 14.1c.7-.4 1.2-1 1.4-1.7.1-.2.1-.5-.1-.7-.2-.3-.8-.1-1.2 0-1.4.7-1.8 1.8-2.5 3 .9 0 1.7-.2 2.4-.6zm-2.3-.4c.2-.7.1-1.5-.2-2.2-.1-.2-.3-.4-.5-.5-.4 0-.7.5-.8.8-.5 1.5 0 2.6.3 3.9.6-.5 1-1.2 1.2-2zm-4.3 4c0-.8-.2-1.5-.7-2.1-.1-.2-.4-.3-.6-.3-.4.1-.6.6-.6 1 0 1.3.4 2.6 1.2 3.7.5-.7.7-1.5.7-2.3zm-1.6 2.1c0-.8-.2-1.5-.7-2.1-.1-.2-.4-.3-.6-.3-.4.1-.6.6-.6 1 0 1.3.4 2.6 1.2 3.7.5-.7.7-1.4.7-2.3zm-2.4 3.1c0-.8-.2-1.5-.7-2.1-.1-.2-.4-.3-.6-.3-.4.1-.6.6-.6 1 0 1.3.4 2.6 1.2 3.7.4-.7.7-1.4.7-2.3zm-2.9 3.8c0-.8-.2-1.5-.7-2.1-.1-.2-.4-.3-.6-.3-.4.1-.6.6-.6 1 0 1.3.4 2.6 1.2 3.7.4-.7.7-1.5.7-2.3zm9.5-10.3c.6-.2 1.3-.3 1.9-.3.6 0 1.2.1 1.7.3.3.1.5.4.5.7 0 .3-.2.6-.5.6-.3.1-.6.1-.9 0-.9-.2-1.9-.6-2.7-1.3zm-3.1 3.5c.6-.2 1.3-.3 1.9-.3.6 0 1.2.1 1.7.3.3.1.5.4.5.7 0 .3-.2.6-.5.6-.3.1-.6.1-.9 0-1-.1-2-.6-2.7-1.3-.1.1 0 0 0 0zm1.7-1.8c.7-.1 1.3-.2 2-.1.6 0 1.2.2 1.7.5.3.2.5.5.5.8-.1.3-.3.5-.6.6-.3.1-.6.1-.9 0-1-.3-2-.9-2.8-1.6.1-.1.1-.2.1-.2zm-4 4.4c.6-.3 1.2-.5 1.9-.6.6-.1 1.2-.1 1.8.1.3.1.6.3.6.7 0 .3-.1.6-.4.7-.3.1-.6.2-.9.2-1.1-.1-2.1-.4-3-.9v-.2zm-7.6 10.7c.6-.3 1.2-.5 1.9-.6.6-.1 1.2-.1 1.8.1.3.1.5.3.6.6 0 .3-.2.6-.4.7-.3.1-.6.2-.8.2-1.1-.1-2.1-.4-3-.9-.2 0-.1-.1-.1-.1zm4.8-6.4c.6-.3 1.2-.5 1.9-.6.6-.1 1.2-.1 1.8.1.3.1.5.3.6.6 0 .3-.1.6-.4.7-.3.1-.6.2-.9.2-1.1-.1-2.1-.4-3-.9-.1 0 0-.1 0-.1zm6.4-8.7c.5-.8.9-1.6 1.1-2.5.1-.3.1-.7.1-1 0-.3-.2-.7-.4-.9-.2-.2-.6-.3-.9-.2-.4.2-.6.6-.6 1s.1.8.2 1.1c.3.7.5 2.5.5 2.5z"
        transform="translate(79.56 36.06)"
      />
      <path
        className="st1"
        d="M44 14.2c-2 1.7-3.9 3.7-5.5 5.8-1.7 2.2-3.4 4.5-5.1 6.7-3.4 4.5-6.7 9.1-9.8 13.9-1.7 2.7-3.3 5.5-4.7 8.3 0 .1.1.1.1 0 5.2-9.9 12-19 18.8-27.9 1.9-2.3 3.9-4.6 6.2-6.8z"
        transform="translate(79.56 36.06)"
      />
      <path
        className="st29"
        d="M94.5 60.9c0 1.3.4 2.5 1.2 3.5.6 1.2 1.5 2.2 2.7 2.9.1-.6.1-1.2 0-1.7-.3-2.1-1.7-3.8-3.7-4.6l-.2-.1zm6 3.9c-.6 1.1-.9 2.4-.7 3.7 0 1.3.3 2.7.9 3.8.4-.4.7-1 .8-1.5.7-2 .4-4.2-.9-5.8l-.1-.2zm2.5 5.5c-.7 1-1.1 2.3-1 3.5-.1 1.3.1 2.7.7 3.9.4-.4.7-.9.9-1.5.9-2 .7-4.2-.6-5.9.1-.1 0 0 0 0zM93.4 66.8c.6 1.1 1.6 2 2.8 2.5 1.1.7 2.4 1.1 3.7 1.2-.2-.6-.5-1.1-.9-1.5-1.3-1.6-3.4-2.5-5.5-2.2h-.1zm2 4.7c.6 1.1 1.6 2 2.8 2.5 1.1.7 2.4 1.1 3.7 1.2-.2-.6-.5-1.1-.9-1.5-1.3-1.6-3.4-2.5-5.5-2.2h-.1z"
      />
      <path
        className="st29"
        d="M104.6 85.5c-1.4-7.6-4.2-15-8.2-21.6l.2-.1c4 6.7 6.8 14 8.2 21.7 0-.1-.2 0-.2 0zm1.3-.8l-.2-.1c1.6-3.8 2.4-7.9 2.4-12.1 0-4-.6-7.9-1.6-11.7h.2c1 3.8 1.5 7.8 1.6 11.8 0 4.1-.8 8.2-2.4 12.1z"
      />
      <path
        className="st29"
        d="M105 61.4c.4.9 1.2 1.6 2.2 1.7.6-.5.8-1.3.7-2-.1-.9-.4-1.8-1-2.6-.6-.7-1.2-1.3-1.8-1.9 0 .4-1.2 2.6-.1 4.8zm2.9 6.3c-.1-1.5-.9-2.9-2.1-3.8-.9-.7-1.8-1.2-2.9-1.5.4 1.2 1.1 2.3 1.9 3.3.8.9 1.9 1.6 3.1 2zm.3 3.5c-.1-1.5-.9-2.9-2.1-3.8-.9-.7-1.9-1.2-2.9-1.5.4 1.2 1.1 2.3 1.9 3.3.8.9 1.9 1.6 3.1 2zm-.1-2.5c-.4-1.4-.2-3 .6-4.3.6-.9 1.3-1.8 2.2-2.4 0 1.3-.2 2.6-.7 3.8-.4 1.1-1.2 2.1-2.1 2.9zm0 4.7c0-1.5.6-3 1.7-4 .8-.8 1.7-1.4 2.8-1.8-.3 1.3-.8 2.4-1.6 3.5-.7 1-1.7 1.8-2.9 2.3zm-.4 4.1c.2-1.5 1.1-2.8 2.3-3.6.9-.6 1.9-1.1 3-1.3-.5 1.2-1.2 2.3-2.1 3.2-.9.7-2 1.3-3.2 1.7z"
      />
      <path
        className="st10"
        d="M46.2 68c-.1-.2-.2-.4-.1-.6.1-.4.3-.9.7-.9.3 0 .6.2.6.6 0 .3-.1.7-.3.9-.4.4-.8.2-.9 0zm-2.3.7c-.2 0-.4-.1-.6-.2-.3-.3-.5-.7-.3-1.1.2-.2.5-.3.8-.2.3.1.5.4.6.7.1.6-.4.8-.5.8zm-.5-3.3c-.2 0-.4-.1-.6-.2-.3-.3-.5-.7-.3-1.1.2-.2.5-.3.8-.2.3.2.5.4.6.7.1.6-.3.8-.5.8zm-.5-3.3c-.2 0-.4-.1-.6-.2-.3-.3-.5-.7-.3-1.1.2-.2.5-.3.8-.2.3.1.5.4.6.7.1.6-.3.8-.5.8zm-1.3-2.8c-.2 0-.4-.1-.6-.2-.3-.3-.5-.7-.3-1.1.2-.2.5-.3.8-.2.3.2.5.4.6.7.1.6-.3.8-.5.8zm-1.3-2.8c-.2 0-.4-.1-.6-.2-.3-.3-.5-.7-.3-1.1.2-.2.5-.3.8-.2.3.2.5.4.6.7.2.7-.3.8-.5.8zm1.6-2.4c-.2 0-.4-.1-.6-.2-.3-.3-.5-.8-.3-1.1.2-.2.5-.3.8-.2.3.2.5.4.6.7.1.6-.3.7-.5.8zm4 10.7c-.1-.2-.2-.4-.1-.6.1-.4.3-.9.7-.9.3 0 .6.3.6.6s-.1.7-.3.9c-.5.4-.8.1-.9 0zm-.4-3.3c-.1-.2-.2-.4-.1-.6.1-.4.3-.9.7-.9.3 0 .6.2.6.5s-.1.7-.3.9c-.4.5-.8.2-.9.1zm-1.1-2.8c-.1-.2-.2-.4-.1-.6.1-.4.3-.9.7-.9.3 0 .6.2.6.5s-.1.7-.3.9c-.4.5-.8.2-.9.1zm-1.1-2.8c-.1-.2-.2-.4-.1-.6.1-.4.3-.9.7-.9.3 0 .6.2.6.5s-.1.7-.3.9c-.4.5-.8.2-.9.1z"
      />
      <path
        className="st10"
        d="M41 54.7c2.5 4 4 8.5 4.5 13.1.4 4.1.4 8.3-.1 12.5-.2 2.2-.6 4.4-.9 6.6 0 .1.1.1.2 0 .5-2 .8-4 .9-6 .2-2.2.3-4.5.4-6.7.2-4.2-.4-8.5-1.6-12.5-.7-2.5-1.9-4.8-3.4-7 .1 0 0 0 0 0z"
      />
      <path
        className="st1"
        d="M36.1 87.5c-.9-8.5-3.9-16.6-8.8-23.6-1.4-2-2.9-3.9-4.6-5.7-.1-.1-.2 0-.1.1 5.8 6.3 10 13.9 12.1 22.2.6 2.3 1 4.7 1.4 7-.1.1 0 0 0 0z"
      />
      <path
        className="st1"
        d="M26.1 62.7c-1.3-.7-2.6-1.6-3.8-2.5-1.2-.9-2.2-2.1-2.8-3.5-.3-.8-.4-1.9.2-2.4.5-.3 1.1-.3 1.5 0 .5.3.8.7 1.1 1.1 1.7 2.2 3 4.7 4 7.3.2.2-.2 0-.2 0zm3.8 5.6c-1.3-2.6-4.1-4.1-7-3.7-.5.1-1 .3-1.4.6-.5.4-.8 1.1-.5 1.7.3.4.8.7 1.3.8.5 0 .9 0 1.4-.2 2-.3 4-.1 5.9.6.1.1.2.2.3.2zm2.2 4.4c-1.3-2.6-4.1-4.1-7-3.7-.5.1-1 .3-1.4.6-.5.4-.7 1.1-.5 1.7.3.4.8.7 1.3.8.5 0 .9 0 1.4-.1 2-.3 4-.1 5.9.6.1-.1.2 0 .3.1zm-3.7-6.8l-.9-2.1c-.2-.5-.3-.9-.4-1.4-.2-1.4.2-2.8 1.2-3.8.4-.5.9-.8 1.5-1 .6-.2 1.3-.1 1.8.3s.7 1 .5 1.7c-.3.6-.8 1.1-1.3 1.5-1.5 1-2.5 2.8-2.4 4.8zm2.6 4.7l-.9-2.1c-.1-.5-.3-1-.4-1.5-.2-1.4.2-2.8 1.1-3.8.4-.5.9-.8 1.5-1 .6-.2 1.3-.1 1.8.3s.7 1 .5 1.7c-.3.6-.8 1.1-1.3 1.5-1.4 1.1-2.3 2.9-2.3 4.9z"
      />
      <path
        className="st29"
        d="M37.2 66.3c.2 1.7-.2 3.7-2.2 4-1.7.1-3.2-.9-3.9-2.4 0-.1-.2 0-.1.1.9 1.5 2.4 2.8 4.2 2.5 2-.4 2.5-2.4 2.2-4.2h-.2z"
      />
      <path
        className="st29"
        d="M35.3 66c.3.7.5 1.4.5 2.2-.1.7-.3 1.4-.6 2 0 0 0 .1.1.1h.1c.8-1.3.8-3.1-.1-4.3z"
      />
      <path
        className="st29"
        d="M33.9 66.7c.1 1.3.6 2.5 1.4 3.5.1.1.2 0 .2-.1-.3-.5-.6-1-.9-1.6-.3-.6-.5-1.2-.7-1.8.1-.1 0-.1 0 0zm-1.9.2c.2.8.6 1.6 1.2 2.2.5.6 1.2 1.1 2 1.3.1 0 .1-.1 0-.2-.3-.2-.7-.4-1-.6-.3-.2-.7-.5-.9-.8-.5-.5-.9-1.2-1.3-1.9zm5.7-.9c.2.1.2.3.1.5-.1.1-.2.2-.3.2-.2.1-.4.1-.6-.1-.2-.1-.3-.4-.2-.6.1-.2.3-.3.5-.3.2.1.4.2.5.3z"
      />
      <path
        className="st29"
        d="M31.9 67.1c-.2 0-.4 0-.5-.1-.1-.1-.1-.2-.1-.3 0-.2.1-.3.3-.4.2-.1.4 0 .6.1.1.1.2.3.1.5-.1.1-.3.2-.4.2zm3.6-.9c-.2.1-.4 0-.5-.1-.1-.1-.1-.2-.1-.3 0-.2.1-.3.3-.4.2-.1.4 0 .6.1.1.1.1.3 0 .5-.1.1-.2.2-.3.2zm-4.1 1.7c.2.1.2.3.1.5-.1.1-.2.2-.3.2-.2.1-.4 0-.6-.1-.2-.1-.3-.4-.2-.6.1-.2.3-.3.5-.3.2.1.4.2.5.3zm2.7-2.1c.1.2.2.4.1.7 0 .1 0 .1-.1.1-.1.1-.3.2-.5.2s-.4-.1-.5-.3c0-.1-.1-.1-.1-.2s0-.3.1-.4c.1-.1.3-.2.5-.2.3-.1.4 0 .5.1zm.9 3.9c.8 2.9 1.4 5.9 1.8 8.9.3 3.1.4 6.2.3 9.3 0 .1.1.1.1.1s.1 0 .1-.1c.2-3 .1-6.1-.3-9.1-.2-3.2-.9-6.2-2-9.1.1-.1.1-.1 0 0 .1-.1 0-.1 0 0 0-.1 0 0 0 0z"
      />
      <path
        className="st29"
        d="M35.3 72.7c-.3.4-.7.8-1.2.9-.2-.5-.1-1.1.2-1.5.3-.4.7-.8 1.2-.9.1.4.1 1-.2 1.5zm1.1-.4c-.5-.3-.8-.7-.9-1.2.5-.1 1.1-.1 1.5.2.4.3.7.7.9 1.2-.5.1-1 0-1.5-.2zm-8.7-.3c.9 1.3 1.5 3 .1 4.2-1.3.8-3 .8-4.2-.1-.1-.1-.2.1-.1.2 1.4.8 3.2 1.1 4.5 0 1.4-1.2.8-3.1-.3-4.3.1 0 0 0 0 0z"
      />
      <path
        className="st29"
        d="M26.2 72.6c.5.4 1 .9 1.3 1.4.3.6.4 1.3.5 1.9 0 .1.1.1.1 0 .2-1.3-.6-2.7-1.9-3.3-.1 0 0 0 0 0z"
      />
      <path
        className="st29"
        d="M25.3 73.8c.7 1 1.6 1.7 2.8 2.2.1 0 .2-.1.1-.2-.5-.3-1-.5-1.4-.8-.6-.4-1-.8-1.5-1.2.1 0-.1 0 0 0zm-1.4 1.1c.5.5 1.2.9 1.9 1.1.7.3 1.5.3 2.2.1 0 0 .1-.1 0-.1 0 0-.1-.1-.1 0-.7 0-1.4 0-2.1-.2-.6-.2-1.3-.5-1.9-.9 0-.1 0-.1 0 0zm4.1-3c.2 0 .3.2.3.4 0 .1 0 .2-.1.3-.1.2-.3.2-.5.2s-.4-.2-.4-.4.1-.4.3-.5c.1-.1.2-.1.4 0z"
      />
      <path
        className="st29"
        d="M24 75c-.1.1-.3.2-.4.1-.1 0-.2-.1-.2-.2-.1-.2 0-.3 0-.5.1-.1.3-.2.5-.2s.3.2.3.3c-.1.3-.1.4-.2.5zm2.4-2.3c-.1.1-.3.2-.4.1-.1 0-.2-.1-.2-.2-.1-.2 0-.3.1-.5.1-.1.3-.2.5-.2s.3.2.3.3c-.2.3-.2.4-.3.5zM24 75.8c.2 0 .3.2.3.4 0 .1 0 .2-.1.3-.1.2-.3.2-.5.2s-.4-.2-.4-.4.1-.4.3-.5h.4zm1.1-2.9c.2.1.3.3.4.5v.1c-.1.1-.2.3-.3.4-.2.1-.4.1-.6 0-.1 0-.1-.1-.1-.1-.1-.1-.1-.2-.1-.4s.1-.3.3-.4c.1-.1.3-.2.4-.1zm4.1 5c0 .5-.2.9-.5 1.2-.4-.3-.5-.8-.5-1.3s.2-.9.5-1.3c.3.4.5.9.5 1.4z"
      />
      <path
        className="st29"
        d="M29.8 77.1c-.5 0-.9-.2-1.2-.5.3-.4.8-.6 1.3-.5.5 0 .9.2 1.3.5-.4.3-.9.5-1.4.5z"
      />
      <path
        className="st29"
        d="M27.8 75.8c1.5 1.8 2.8 3.7 3.9 5.7s1.9 4.2 2.4 6.4c0 .1.3.1.2 0 0-.1 0-.3-.1-.4 0-.1-.2-.1-.2 0v.4h.2c-.5-2.3-1.3-4.5-2.4-6.5-1-2.1-2.3-4-4-5.6.1-.1 0 0 0 0zm9.3 3.5c.4 0 .9-.2 1.2-.5.2-.3.4-.7.4-1.1-.5 0-1 .2-1.3.6-.2.3-.2.6-.3 1zm.1 2.1c-.6.1-1.2-.1-1.7-.5-.4-.4-.7-.9-.8-1.5.7-.2 1.5.1 2 .7.3.4.4.9.5 1.3z"
      />
      <path
        className="st29"
        d="M33 83.6c-.5.3-1.2.4-1.8.1-.5-.2-.9-.6-1.2-1.1.6-.4 1.4-.4 2.1-.1.3.3.7.7.9 1.1z"
      />
    </g>
  </svg>
);
